import React from 'react'

import { Button as AntButton, Checkbox as AntCheckbox, CheckboxProps as AntCheckboxProps } from 'antd'
import classnames from 'classnames'

import './styles/checkbox.less'

export interface CheckboxProps extends AntCheckboxProps {
  disabled?: boolean
  onChange?: (e: any) => void
  className?: string
  id?: string
  defaultChecked?: boolean
  checked?: boolean
  value?: string | number
  white?: boolean
  childred?: JSX.Element
}

const Checkbox: React.FC<CheckboxProps> = (props) => {
  const clasNames = classnames({
    'custom-medium-without-title': props.white,
  })
  return (
    <AntCheckbox {...props} className={`${clasNames} ${props.className}`}>
      {props.children}
    </AntCheckbox>
  )
}

const CheckboxButton: React.FC<CheckboxProps> = (props) => {
  const { name, className, checked } = props
  return (
    <div className={`checkbox__button ${className}`}>
      <AntCheckbox {...props} className={`ant-btn pr-16 pl-8 ${checked ? 'outline-green' : ''}`}>
        <div className="checkbox__button-label">{name}</div>
      </AntCheckbox>
    </div>
  )
}

export const PkCheckBox: React.FC<CheckboxProps> = ({ onChange: $onChange, ...props }) => {
  const [active, setActive] = React.useState(props.checked ?? false)
  const classNames = classnames({
    'border-active': active,
  })
  return (
    <div className={`pk-checkbox--wrapper ${classNames}`}>
      <AntCheckbox
        onChange={(e) => {
          setActive(e.target.checked)
          $onChange && $onChange(e)
        }}
        {...props}
        className={`pk-checkbox`}
      >
        <div className="children w-100">{props.children}</div>
      </AntCheckbox>
    </div>
  )
}

export { CheckboxButton }
export default Checkbox
